import { Box, Image, SimpleGrid, useColorMode } from '@chakra-ui/react';
import React from 'react';

function Stats() {
  const { colorMode, toggleColorMode } = useColorMode();
  const isDark = colorMode === 'dark';

  return (
    <SimpleGrid columns={[1, 1, 1, 1]} width="80%" margin="auto" marginTop="50px" gap="30px">
      <a href="https://github.com/Rohit20033">
        <Image
          width="70%"
          margin="auto"
          src={
            isDark
              ? 'https://github-readme-streak-stats.herokuapp.com/?user=Rohit20033&theme=vue-dark&hide_border=true&border_radius=5.5'
              : 'https://github-readme-streak-stats.herokuapp.com/?user=Rohit20033'
          }
        />
      </a>

      <SimpleGrid
        columns={[1, 1, 1, 1]}
        height={['auto', 'auto', 'auto', '300px']}
        display="flex"
        margin="auto"
        gap={['10px', '20px', '30px', '40px']}
        justifyContent="center"
      >
        <a href="https://github.com/Rohit20033">
          <img
            align="center"
            src={
              isDark
                ? 'https://github-readme-stats.vercel.app/api/top-langs/?username=Rohit20033&&theme=vue-dark&hide_border=true&border_radius=5.5'
                : 'https://github-readme-stats.vercel.app/api/top-langs/?username=Rohit20033'
            }
          />
        </a>
        <a href="https://github.com/Rohit20033">
          <img
            align="center"
            src={
              isDark
                ? 'https://github-readme-stats.vercel.app/api?username=Rohit20033&count_private=true&show_icons=true&theme=vue-dark&hide_border=true&border_radius=5.5'
                : 'https://github-readme-stats.vercel.app/api?username=Rohit20033&count_private=true&show_icons=true'
            }
          />
        </a>
      </SimpleGrid>
    </SimpleGrid>
  );
}

export default Stats;
